import {useChekinSDK} from 'context/ChekinSDK';
import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from 'utils/constants';

type Props = {
  id?: string;
};
export const useFetchMultiPayment = ({id}: Props) => {
  const {getMultiPayment} = useChekinSDK();

  return useQuery({
    queryKey: [QUERY_CACHE_KEYS.multiPayment, id],
    queryFn: () => getMultiPayment(id ?? ''),
    enabled: Boolean(id),
    cacheTime: 1000 * 60 * 5,
    staleTime: 1000 * 60 * 5,
  });
};
